import React from 'react';

const RadioIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="6" fill="#62339C" className="inside" />
      <circle cx="9" cy="9" r="8.5" stroke="#62339C" className="outsite" />
    </svg>
  );
};

export default RadioIcon;
